/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanClubTextPostNotificationActionData } from './FanClubTextPostNotificationActionData';
import {
    FanClubTextPostNotificationActionDataFromJSON,
    FanClubTextPostNotificationActionDataFromJSONTyped,
    FanClubTextPostNotificationActionDataToJSON,
} from './FanClubTextPostNotificationActionData';

/**
 * 
 * @export
 * @interface FanClubTextPostNotificationAction
 */
export interface FanClubTextPostNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof FanClubTextPostNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof FanClubTextPostNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FanClubTextPostNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {FanClubTextPostNotificationActionData}
     * @memberof FanClubTextPostNotificationAction
     */
    data: FanClubTextPostNotificationActionData;
}

/**
 * Check if a given object implements the FanClubTextPostNotificationAction interface.
 */
export function instanceOfFanClubTextPostNotificationAction(value: object): value is FanClubTextPostNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function FanClubTextPostNotificationActionFromJSON(json: any): FanClubTextPostNotificationAction {
    return FanClubTextPostNotificationActionFromJSONTyped(json, false);
}

export function FanClubTextPostNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanClubTextPostNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': FanClubTextPostNotificationActionDataFromJSON(json['data']),
    };
}

export function FanClubTextPostNotificationActionToJSON(value?: FanClubTextPostNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': FanClubTextPostNotificationActionDataToJSON(value.data),
    };
}

